/* global jQuery */
const $ = jQuery;

import "./styles/index.scss";
// import './scripts/woo-checkout';
import "./utils/tracking";
import "./scripts/main.js";

import Components from "./components";
import React from "react";
import ReactDOM from "react-dom";

$(document).ready(() => {

  //Load react components
  document.querySelectorAll('[data-react-component]').forEach((el) => {
    const componentName = el.dataset.reactComponent;
    const props = JSON.parse(el.dataset.reactProps || '{}');

    const Component = Components[componentName];

    if (Component) {
      ReactDOM.render(
        React.createElement(Component, props),
        el
      );
    } else {
      console.error(`React component "${componentName}" not found in Components map`);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab" && !e.shiftKey) {
      if (!document.body.classList.contains("tabbing-started")) {
        document.body.classList.add("tabbing-started");
      }
    }

    $(".skip-to-content__link")
      .on("focus", function (e) {
        $(this).addClass("active");
        $(".js-skip-to-content").addClass("active");
      })
      .on("blur", function () {
        $(".js-skip-to-content").removeClass("active");
        $(".skip-to-content__link").removeClass("active");
      });
  });

  const activeContainerClass = "header__mega-container--active";
  const activeChildClass = "header__mega-menu__children--active";
  const activeLinkClass = "header__mega-menu__link--active";
  const activeItemClass = "header__mega-menu__item--isactive";

  const isMobile = window.matchMedia(
    "only screen and (max-width: 1023px)"
  ).matches;

  $(".header__mega-menu__link.js-toggle-children").click(function (e) {
    if (e.target.href === "#") e.preventDefault();

    const $link = $(this);
    const $childMenu = $link.next(".header__mega-menu__children");
    const $parentItem = $link.parent();

    const isActive = $childMenu.hasClass(activeChildClass);

    // Reset all open menus
    $("." + activeLinkClass)
      .removeClass(activeLinkClass)
      .attr("aria-expanded", "false");

    $("." + activeChildClass).removeClass(activeChildClass);
    $("." + activeItemClass).removeClass(activeItemClass);
    $("." + activeContainerClass).removeClass(activeContainerClass);

    if (!isActive) {
      hideSearch();

      $link.addClass(activeLinkClass).attr("aria-expanded", "true");
      $parentItem.addClass(activeItemClass);
      $childMenu.addClass(activeChildClass);
      $(".header__mega-container").addClass(activeContainerClass);

      // // Optional: align submenu to menu
      // const leftOffset = $('.header__mega-menu').offset()?.left || 0;
      // $childMenu.css('padding-left', leftOffset);
    }
  });

  function hideSearch() {
    $(".nav-service__container").removeClass("activesearch");
    $(".header__search__button, .nav-service__search__button").removeClass(
      "active"
    );
    $(".header__search-foldout").removeClass("header__search-foldout--is-open");
    $("#search").blur();
  }

  // Close on click outside
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(
        ".js-toggle-children, .header__mega-menu__title, .sr-only"
      ).length
    ) {
      $("." + activeLinkClass)
        .removeClass(activeLinkClass)
        .attr("aria-expanded", "false");
      $("." + activeChildClass).removeClass(activeChildClass);
      $("." + activeItemClass).removeClass(activeItemClass);
      $("." + activeContainerClass).removeClass(activeContainerClass);
    }
  });

  if ($(".slick-slider") && $(".slick-slider")[0]) {
    $(window).resize(function () {
      $(".slick-slider")[0].slick.refresh();
    });
  }

  $(".carousel__close").click(function () {
    $(".text-imagegallery--modal").removeClass("text-imagegallery--modal");
    $("body").removeClass("noscroll");
    $("html").removeClass("noscroll");
    $(this).parent().find(".slick-slider")[0].slick.refresh();
    if ($(this).parent().find(".slick-slider")[1])
      $(this).parent().find(".slick-slider")[1].slick.refresh();
  });

  $(".carousel__background").click(function () {
    $(".text-imagegallery--modal").removeClass("text-imagegallery--modal");
    $("body").removeClass("noscroll");
    $("html").removeClass("noscroll");
    $(this).parent().find(".slick-slider")[0].slick.refresh();
    if ($(this).parent().find(".slick-slider")[1])
      $(this).parent().find(".slick-slider")[1].slick.refresh();
  });

  var headerInitialHeight = $(".header").outerHeight();

  //front page (new template)
  if ($("body").hasClass("page-template-template-portal-page-new")) {
    $(window).scroll(function () {
      var headerHeight = $(".header").outerHeight();

      if (jQuery(window).scrollTop() > 500) {
        $(".header").addClass("header--sticky");
        $(".header").css("margin-top", -headerHeight);
        $("body").css("margin-top", headerInitialHeight);
      } else {
        $(".header").removeClass("header--sticky");
        $(".header").css("margin-top", 0);
        $("body").css("margin-top", 0);
      }

      if ($(window).scrollTop() > 500) {
        $(".header").addClass("header--slide-down");
      } else {
        $(".header").removeClass("header--slide-down");
      }
    });
  } else {
    $(".header").addClass("header--sticky");

    $(window).resize(function () {
      $("body").css("margin-top", $(".header").outerHeight());
    });

    $(window).resize();
  }

  $(".js-scroll-to").click(function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - "60",
      },
      1100
    );
  });

  $(".js-dropdown").click(function (e) {
    e.preventDefault();
    $(".dropdown-menu__list").toggleClass("dropdown-menu__list--active");
  });
});
